<template>
    <base-dialog v-model="value" title="System Information" :maxWidth="550" @close="$emit('input', false)">
        <template #content>
            <updates-modal />

            <h3 class="text-subtitle-1 font-weight-bold mb-1">Diagnostics</h3>
            <p class="body-1 mb-4">
                If you have been directed by the support team to provide Diagnostic Data, use the download button below,
                and provide the file to the support team as an email attachment.
            </p>

            <v-btn
                color="warning"
                outlined
                class="mb-4"
                @click="downloadTrace()"
                :width="$vuetify.breakpoint.smAndUp ? '' : '100%'"
                :large="!$vuetify.breakpoint.smAndUp"
            >
                <v-icon size="medium">mdi-progress-wrench</v-icon>
                <span class="ml-1">Download Diagnostic Data</span>
            </v-btn>

            <h3 class="text-subtitle-1 font-weight-bold mt-2 mb-0">System</h3>
            <div class="text-caption">
                <a href="/diagnostics" style="text-decoration: none; color: inherit">
                    Version: <span v-if="appPlatform"> {{ appPlatform }} </span>{{ appVersion }}
                </a>
                <br />
                <span v-if="appBuild"> Build: {{ appBuild }} <br /></span>
                API: {{ apiVersion }} @ {{ apiEndpoint }}
                <br />
                Server Time: {{ apiTime }} UTC
                <br />
                Latency: {{ apiResponseTime }}
            </div>
        </template>
    </base-dialog>
</template>

<script>
import store from "@/store";
import diagnostics from "@/diagnostics";
import { InternalService } from "@services";

import UpdatesModal from "@cmp/updates/UpdatesModal";
import BaseDialog from "@cmp/base/BaseDialog";

export default {
    components: {
        UpdatesModal,
        BaseDialog,
    },
    name: "SystemInformationModal",
    props: ["value"],
    data() {
        return {
            appBuild: "",
            appPlatform: "",
            appVersion: null,
            apiEndpoint: null,
            apiVersion: null,
            apiTime: null,
            apiResponseTime: null,
            showUpdatesModal: false,
        };
    },
    methods: {
        getApiVersion() {
            InternalService.versionGet().then((r) => {
                this.apiVersion = r.data.version;
            });
        },

        getApiTime() {
            const t0 = performance.now();
            InternalService.serverTimeGet().then((r) => {
                const t1 = performance.now();
                const responseTime = Math.round((t1 - t0) * 10) / 10;
                this.apiTime = r.data.utc;
                this.apiResponseTime = `${responseTime.toFixed(1)} milliseconds`;
            });
        },
        downloadTrace() {
            diagnostics.exportAsync();
        },
    },

    mounted() {
        this.appVersion = store.state.settings.version;
        this.apiEndpoint = store.state.api.apiURL;
        this.getApiVersion();
        this.getApiTime();
    },
};
</script>

<style scoped>
h3 {
    margin-bottom: 8px;
}
.rounded-button {
    background-color: #777777;
    border-radius: 50%;
    color: #cecece;
}
</style>
